import { Grid, Elements } from '@tfo/common'
import { observer } from 'mobx-react'
import * as React from 'react'
import { injectIntl, useIntl, WrappedComponentProps } from 'react-intl'
import { useHistory } from 'react-router-dom'
import AbortApprovalModal from '../../../../components/modals/abort-approval-modal/AbortApprovalModal'
import $http from '../../../../utils/$http'
import AboutBackgroundCheck from '../../common/about-background-check/AboutBackgroundCheck'
import Attachments from '../../common/attachments/Attachments'
import IndividualHeader from '../../common/individual-header/IndividualHeader'
import Instructions from '../../common/instructions/Instructions'
import ReportDetails from '../../common/report-details/ReportDetails'
import { OngoingViewModel } from '../../ViewModels'

import AdditionalInformation from '../../common/attachments/AdditionalInformation'
import SignedDocuments from '../../common/attachments/SignedDocuments'
import './Ongoing.scss'
const { Paragraph } = Elements

type OngoingProps = OngoingViewModel & {
	setIsLoading: (loading: boolean) => void
}

const Ongoing: React.FunctionComponent<OngoingProps &
	WrappedComponentProps> = props => {
		const { 
			orderId, 
			companyName, 
			approved, 
			estimatedDeliveryDate, 
			isIDD, 
			canWithdraw, 
			canAttachFile, 
			canAttachAdditionalInformation,
			setIsLoading } = props
		const history = useHistory()
		const intl = useIntl()

		const [showDenyApprovalModal, setShowDenyApprovalModal] = React.useState<boolean>(false)

		const denyOrder = () => {
			setIsLoading(true)
			setShowDenyApprovalModal(false)
			$http.post(`deny/${orderId}`, null)
				.then(o => {
					//Refresh site to receive updated list
					history.go(0)
				})
				.catch(() => {
					//handle this more gracefully
					console.error("failed sending deny")
					setIsLoading(false)
				})
		}

		let typeOfText: string = ''
		if (isIDD) {
			typeOfText = 'ongoing.IDD'
		}
		else if (canAttachFile) {
			typeOfText = 'ongoing.International'
		}
		else {
			typeOfText = 'ongoing'
		}


		return (
			<React.Fragment>
				<Grid.GridWrapper className="IndividualView Ongoing">
					<IndividualHeader
						companyName={companyName}
						headingId="ongoing.heading"
						preambleId={typeOfText + '.body'}
						preambleData={{
							date: props.intl.formatDate(approved),
							time: props.intl.formatTime(approved),
							companyName: companyName,
						}}
					/>

					{props.instructions && <Instructions {...props} />}
					{(canAttachFile || canAttachAdditionalInformation) && <Paragraph className='paragraph'>{intl.formatMessage({ id: 'requireAttachments.additional-information.header' })}</Paragraph>}
					{canAttachFile && <Attachments  {...props} />}
					<SignedDocuments {...props} />			
					{canAttachAdditionalInformation && <AdditionalInformation orderId={orderId} body={props.additionalInformation} />}
					<AboutBackgroundCheck order={props} isOngoing={true} />

					<ReportDetails
						captionId={'ongoing.availability.caption'}
						availabilityId={'ongoing.availability.date'}
						availabilityData={estimatedDeliveryDate
							? { date: props.intl.formatDate(estimatedDeliveryDate) }
							: null}
						buttonId={'ongoing.btn.abort'}
						buttonIsSecondary
						onClickCallback={() => {
							setShowDenyApprovalModal(true)
						}}
						showActionButton={canWithdraw}
					/>

				</Grid.GridWrapper>
				{showDenyApprovalModal ? (
					<AbortApprovalModal
						onDenyClick={() => setShowDenyApprovalModal(false)}
						onCloseClick={() => setShowDenyApprovalModal(false)}
						onConfirmClick={() => denyOrder()}
						companyName={companyName}
					/>
				) : null}
			</React.Fragment>
		)
	}

export default injectIntl(observer(Ongoing))
